import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { liveDataSelector } from '../../../../redux/reducers/domain/centrifugo/liveData';

export const useGameAdditionalInfo = (gameId) => {
  const liveData = useSelector(liveDataSelector);

  const empty = useMemo(() => ({}), []);

  const gameData = useMemo(() => {
    return liveData[gameId];
  }, [liveData, gameId]);

  return useMemo(() => {
    if (!gameData) {
      return empty;
    }

    return gameData;
  }, [empty, gameData]);
};
